import { hasServiceConsent } from './consent';

export const META_PIXEL_ID = '3364876777011098';
export const GOOGLE_ADS_ID = 'AW-18005496144';
export const GTM_ID = 'GTM-WFZZ58HF';

export interface MetaQueue {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: MetaQueue;
  loaded: boolean;
  version: string;
}

declare global {
  interface Window {
    fbq?: MetaQueue;
    _fbq?: MetaQueue;
  }
}

let metaReady = false;
export function setMetaReady(ready: boolean): void { metaReady = ready; }
export function canFireMeta(): boolean {
  return metaReady && hasServiceConsent('metaPixel') && typeof window.fbq === 'function';
}

export function googleConsentState() {
  const analytics = hasServiceConsent('ga4');
  const ads = hasServiceConsent('googleAds');
  return {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: ads ? 'granted' : 'denied',
    ad_user_data: ads ? 'granted' : 'denied',
    ad_personalization: ads ? 'granted' : 'denied',
  };
}

export function googleCommand(..._args: unknown[]): void {
  const w = window as Window & { dataLayer?: unknown[]; gtag?: (...args: unknown[]) => void };
  w.dataLayer = w.dataLayer || [];
  w.gtag = w.gtag || function () { w.dataLayer?.push(arguments); };
  w.gtag(..._args);
}